import React from "react";
export const AppContext = React.createContext(false);
export const MenuContext = React.createContext(false);